// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { invProductId } from './InvProduct';
import { brewBatchId } from './BrewBatch';
import { z } from 'zod';
export const foodProductCompositionId = (z.number());
export const foodProductComposition = z.object({
    id: foodProductCompositionId,
    product_id: invProductId,
    display_order: z.number(),
    name: z.string(),
    percentage: z.number().nullable(),
    source_product_id: invProductId.nullable(),
    brew_batch_id: brewBatchId.nullable(),
    created_at: z.date(),
    stand_in_brew_batch_id: brewBatchId.nullable(),
});
export const foodProductCompositionInitializer = z.object({
    id: foodProductCompositionId.optional(),
    product_id: invProductId,
    display_order: z.number().optional(),
    name: z.string(),
    percentage: z.number().optional().nullable(),
    source_product_id: invProductId.optional().nullable(),
    brew_batch_id: brewBatchId.optional().nullable(),
    created_at: z.date().optional(),
    stand_in_brew_batch_id: brewBatchId.optional().nullable(),
});
export const foodProductCompositionMutator = z.object({
    id: foodProductCompositionId.optional(),
    product_id: invProductId.optional(),
    display_order: z.number().optional(),
    name: z.string().optional(),
    percentage: z.number().optional().nullable(),
    source_product_id: invProductId.optional().nullable(),
    brew_batch_id: brewBatchId.optional().nullable(),
    created_at: z.date().optional(),
    stand_in_brew_batch_id: brewBatchId.optional().nullable(),
});
//# sourceMappingURL=FoodProductComposition.js.map